<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import LoginPage from '../../auth/pages/login/LoginPage.vue'

definePage({
    meta: {
        isGuest: true,
    }
})
</script>

<template>
  <LoginPage />
</template>